module.exports = __webpack_public_path__ + "static/media/10674804.7ef1529c.png";